import React, { FC, useEffect, useMemo, useState } from 'react';
import './ReleaseNotes.scss';
import Button from '@atoms/Button';
import { MdClose, MdInfo } from 'react-icons/md';
import { ReleaseNotesService } from '@services/ReleaseNotesService';
import DOMPurify from 'dompurify';
import { IReleaseShortNotesDto } from '@models/releaseNotes/IReleaseShortNotesDto';
import { useLocalStorage } from 'usehooks-ts';
import { useTypedSelector } from '@hooks/useTypedSelector';

const ReleaseNotes: FC = () => {
    const currentUser = useTypedSelector((state) => state.auth.user);
    const [note, setNote] = useState<IReleaseShortNotesDto>();
    const [hintDismissed, setHintDismissed] = useLocalStorage<boolean>(
        `user-${currentUser.username}.releaseNotes.${note?.key}`,
        false,
    );

    useEffect(() => {
        ReleaseNotesService.fetchLastItem().then(function (response) {
            if (response?.data?.key) {
                setNote(response.data);
            }
        });
    }, []);

    const replaceLinkText = (data: IReleaseShortNotesDto): string => {
        const url = `releasenotes?key=${data.key}`;
        let dataText = data.short;
        dataText = dataText?.replace('%link%', url);
        return dataText;
    };

    const text = useMemo(() => {
        return note ? replaceLinkText(note) : null;
    }, [note]);

    return note && !hintDismissed && text ? (
        <div className="rf-releasenotes">
            <div className="rf-releasenotes-bar" id="releaseNotes">
                <div className="rf-releasenotes-icon">
                    <MdInfo size="24" />
                </div>
                <div
                    className="rf-releasenotes-content"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
                    id="rf-releasenotes-content"
                />
                <div className="rf-releasenotes-close" id="rf-releasenotes-close">
                    <Button
                        buttonType="text"
                        textColor="neutral"
                        size="xs"
                        aria-label="Закрыть окно"
                        onClick={() => {
                            setHintDismissed(true);
                        }}
                        startAdornment={<MdClose size="24" />}
                    />
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default ReleaseNotes;
